// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1efJh","colBig":"styles_colBig__j0BaE","colSmall":"styles_colSmall__32hpR"};